'use strict';

// import $ from 'jquery';  // used by Foundation
import { Foundation } from 'foundation/foundation.core';
import { DropdownMenu } from 'foundation-sites/js/foundation.dropdownMenu';
import './component.scss';

const SUBMENU_PARENT_HOOK = '.is-dropdown-submenu-parent',
      OPEN_MENU = 'js-dropdown-active',
      OPEN_MENU_HOOK = '.' + OPEN_MENU,
      NAV_MENUS = document.querySelectorAll('.header-navigation'),
      SUB_MENUS = document.querySelectorAll(SUBMENU_PARENT_HOOK);


function init() {
    Foundation.plugin(DropdownMenu);
    Foundation.reflow(document, 'dropdown-menu');
    handleSubmenuClosing();
    handleEscPress();
    overrideAttributes();
}

function handleSubmenuClosing () {
    for (let menu of NAV_MENUS) {
        menu.addEventListener('focusout', (e) => {
            let nextFocusedEl = e.relatedTarget,
                nextParent = nextFocusedEl && nextFocusedEl.closest(OPEN_MENU_HOOK),
                currTarget = e.target,
                currParent = currTarget.nextSibling ? currTarget.nextSibling : currTarget.closest(OPEN_MENU_HOOK);

            // The only reason to check if nextParent is defined is to safely call nextParent.isSameNode(currParent).
            // nextParent is not used outside of that condition
            const isSameOrNonDropdownParent = currParent && ((nextParent && nextParent.isSameNode(currParent)) || !currParent.classList.contains('is-dropdown-submenu'));

            if (isSameOrNonDropdownParent) {
                return;
            } else {
                if (currParent) {
                    let currentParentListItem = currParent.closest('li');

                    if (currentParentListItem) {
                        currentParentListItem.classList.remove('is-active');
                        currentParentListItem.setAttribute('data-is-click', 'false');
                    }

                    currParent && currParent.classList.remove(OPEN_MENU);
                    currParent && currParent.previousSibling.setAttribute('aria-expanded', 'false');
                }
            }
        });

        menu.addEventListener('keyup', (e) => {
            let code = e.keyCode ? e.keyCode : e.which; // keyCode might not be working in all browsers

            // if not ESC
            if (code !== 27) {
                return;
            } else {
                let openSubmenus = menu.querySelectorAll('[aria-expanded="true"]');

                for (let openSubmenu of openSubmenus) {
                    openSubmenu.setAttribute('aria-expanded', 'false');
                }
            }
        });
    }
}

function handleEscPress() {
    for (let subMenu of SUB_MENUS) {
        subMenu.addEventListener('keyup', (e) => {
            let code = e.keyCode ? e.keyCode : e.which; // keyCode might not be working in all browsers

            // if ENT; SpaceBar or ArrowDown key
            if (code == 13 || code == 32 || code == 40) {
                let parentSubMenu = e.target.closest(SUBMENU_PARENT_HOOK),
                    menuItem = parentSubMenu.querySelector('[role="menuitem"]');

                menuItem.setAttribute('aria-expanded', 'true');
            }
        });
    }
}

/*
 * With the given attributes set on the <li> the SR considers the elements like different types.
 * Example: The navigation menu is with 3 items (1 direct link and 2 dropdowns)
 * The reader will read: "one of one" for the direct link and "one of two" for the first dropdown link.
 * To be removed when works as expected by default.
 */

function overrideAttributes() {
    let dropdownSubmenus = document.querySelectorAll('.is-dropdown-submenu-parent');

    for (let menu of dropdownSubmenus) {
        menu.removeAttribute('aria-haspopup');
        menu.removeAttribute('aria-label');

        /*
         * The aria-haspopup is needed because of the SR.
         * With it the SR recognize the element as a subMenu.
         */
        let link = menu.querySelector('a');

        if (link) {
            link.setAttribute('aria-haspopup', 'true');
        }
    }
}

window.addEventListener('DOMContentLoaded', init);
